import { getFetch } from "../../utils/fetch";

async function getPerson(term) {
  const data = await getFetch(`/ReportWeb/Person?term=${term}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { getPerson };
